<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <p class="hdg02 mb20">マイリンク管理</p>
          <p class="txt-sup mb0">当サイト内外を問わず、普段よく利用するページのURLをダッシュボードに10件まで登録いただけます。</p>
        </div>
        <div class="popup-content">
          <div class="popup-content-hdg">
            <p class="hdg03 line mb0">マイリンクの編集</p>
          </div>
          <div class="popup-content-box">
            <ul class="list">
              <li>
                <div class="hdg">リンクのタイトル</div>
                <div class="formparts text">
                  <input type="text" v-model="group1.title" placeholder="タイトル">
                </div>
                <p v-if="group1.error_title !== ''">{{ group1.error_title }}</p>
              </li>
              <li>
                <div class="hdg">リンクのURL</div>
                <div class="formparts function">
                  <input type="text" v-model="group1.url">
                  <div class="button">
                    <div class="checkbox" role="button">
                      <input type="checkbox" v-model="group1.new_window" id="cb_01_01">
                      <label for="cb_01_01">別window<FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </div>
                <p v-if="group1.error_url !== ''">{{ group1.error_url }}</p>
              </li>
              <li>
                <div class="button submit"
                  @click="group1.onSaveButtonClicked"
                >
                  <span class="btn" role="button">保存</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import * as logicMyLinkEdit from '@/logic/dashboard/MyLinkEdit'

export default defineComponent({
  props: {
    myLinkTargetParams: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicMyLinkEdit.getGroup(props, context)

    const close = () => {
      context.emit('closeMyLinkEdit')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    background-color: $color-bg-form;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &-hdg {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .hdg03 {
        width: calc(100% - 130px);
        padding-right: 20px;
      }
      .link {
        display: block;
        width: 130px;
        color: $color-link;
        font-size: 1.6rem;
      }
    }
    &-box {
      .list {
        list-style: none;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid $color-line;
        li {
          padding: 32px 40px;
          .hdg {
            color: $color-hdg;
            font-size: 2.0rem;
            font-weight: bold;
            margin-bottom: 16px;
          }
          .formparts.function {
            .button {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 120px;
              .checkbox {
                input {
                  display: none;
                }
                input:checked + label .icn {
                  opacity: 1;
                }
                label {
                  padding-left: 30px;
                  position: relative;
                  color: $color-content;
                  font-size: 1.6rem;
                  &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 1;
                    display: block;
                    width: 20px;
                    height: 20px;
                    background-color: #fff;
                    border-radius: 4px;
                  }
                  .icn {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    z-index: 2;
                    color: $color-link;
                    font-size: 1.4rem;
                    opacity: 0;
                    transition: none;
                  }
                }
              }
            }
          }
          & + li {
            border-top: 1px solid $color-line;
          }
          .submit {
            width: 230px;
            margin: 0 auto;
          }
        }
      }      
    }
  }
}
</style>
